function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgMail = function SvgMail(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 36.46 25",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M31.25 25H5.21C2.34 25 .01 22.66 0 19.79V2.08L3.65 5.2l13.54 11.2c.6.52 1.49.52 2.08 0L35.94 2.6l.52-.52v17.71c0 2.87-2.34 5.2-5.21 5.21m3.38-25L18.22 13.54 1.82 0z",
    style: {
      fill: "#414a5f"
    }
  }));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgMail);
export default ForwardRef;